import { render, staticRenderFns } from "./PaymentIntents.vue?vue&type=template&id=00ca81de&"
import script from "./PaymentIntents.vue?vue&type=script&lang=ts&"
export * from "./PaymentIntents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports